import * as theme from '../theme';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function TruCard({ 
  children, 
  onClick, 
  onMouseEnter, 
  onMouseLeave, 
  collapsible = false, 
  expanded: controlledExpanded, 
  defaultExpanded = true, 
  onToggle,
  ...props 
}) {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  
  const isControlled = controlledExpanded !== undefined;
  const expanded = isControlled ? controlledExpanded : internalExpanded;

  const toggleExpanded = () => {
    const newExpanded = !expanded;
    if (isControlled) {
      if (onToggle) onToggle(newExpanded);
    } else {
      setInternalExpanded(newExpanded);
    }
  };

  const handleHeaderClick = (e) => {
    if (collapsible) {
      toggleExpanded();
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div
      style={{ ...theme.TruCard, ...props.styles }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div 
        style={{ 
          ...theme.TruCard.Header, 
          display: 'flex', 
          alignItems: 'center',
          cursor: collapsible ? 'pointer' : 'default',
          position: 'relative'
        }}
        onClick={handleHeaderClick}
      >
        {/* Left spacer to balance the toggle icon so title stays centered when collapsible */}
        {collapsible && <span style={{ width: 40, flexShrink: 0 }} aria-hidden="true" />}

        <span style={{ flex: 1, textAlign: 'center' }}>
          {props.title}
        </span>

        {collapsible && (
          <IconButton 
            size="small" 
            onClick={(e) => { 
              e.stopPropagation(); 
              toggleExpanded(); 
            }}
            aria-label={expanded ? 'Collapse section' : 'Expand section'}
            sx={{ color: 'inherit', flexShrink: 0 }}
          >
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        )}
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div style={{ ...theme.TruCard.Content, ...props.childStyles }}>
          {children}
        </div>
      </Collapse>
    </div>
  );
}